var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGredCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2539 0.400024C15.0248 0.400024 14.603 0.443864 13.9875 0.529784C13.372 0.616184 12.9741 0.699544 12.7947 0.778744C12.6147 0.857624 12.2894 1.13202 11.8198 1.59826C11.3498 2.06642 10.6678 2.9301 9.77616 4.18898C8.8832 5.4493 8.0504 6.77938 7.27616 8.18098C6.49087 9.60454 5.76748 11.0614 5.108 12.5474C4.4872 11.4847 3.9264 10.7642 3.4224 10.3853C2.92 10.0048 2.496 9.81506 2.1512 9.81506C1.88192 9.81506 1.5448 9.95858 1.13792 10.2445C0.73152 10.5309 0.52832 10.8115 0.52832 11.0883C0.52832 11.2885 0.71472 11.5853 1.08768 11.9778C1.82624 12.7581 2.48 13.5858 3.04576 14.4616C3.39136 14.9855 3.62128 15.3071 3.73584 15.4243C3.84976 15.5403 4.19696 15.6 4.77744 15.6C5.58512 15.6 6.06496 15.4965 6.21744 15.288C6.36864 15.0875 6.64864 14.4896 7.05664 13.4928C8.06512 10.9971 9.31904 8.61378 10.8178 6.34466C12.3178 4.07666 13.6917 2.36066 14.9426 1.19826C15.1917 0.977464 15.3413 0.834264 15.3939 0.768184C15.4451 0.701784 15.4714 0.635064 15.4714 0.565624C15.4714 0.455864 15.3987 0.400024 15.2539 0.400024Z",
    fill: "#919EAB",
    fillOpacity: 0.24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGredCheck);
export default __webpack_public_path__ + "static/media/gred-check.a4cae1accd04f8fda41f10d5ffd13f0f.svg";
export { ForwardRef as ReactComponent };